<script setup>
import { ref, onBeforeMount } from 'vue'
import { getKeyGuest } from '@/api/2023/index.js'

const iscArr=ref([])

const getInfo=()=>{
  getKeyGuest().then(res=>{
    iscArr.value=res.data.data.slice(0,9)
  })
}

onBeforeMount(async () => {
  await getInfo()
})

function toMore() {
  const path = `${window.location.origin}/new/2023/guest.html`
  window.open(path)
}
</script>
<template>
  <div class="isc">
    <img class="iscBgc" src="https://p0.ssl.qhimg.com/t01d17161bff7a9c927.png" alt="背景图" />
    <div class="wrap">
      <p class="wrapTitle">重磅嘉宾</p>
      <p class="wrapDesc">IMPORTANT GUESTS</p>
      <ul class="wrapList">
        <li v-for="item in iscArr" :key="item.name" class="wrapListLi">
          <img :src="item.avatar" alt="" />
          <p class="wrapListLiName">{{ item.name }}</p>
          <span v-for="i in item.title" :key="i" class="wrapListLiDesc">
            {{ i }}
          </span>
        </li>
      </ul>
    </div>
    <img
      class="iscMore"
      src="https://p0.ssl.qhimg.com/t014dd2729b5fb029e9.png"
      alt="查看更多"
      @click="toMore"
    />
  </div>
</template>
<style lang="scss" scoped>
.isc {
  position: relative;
  background: rgb(247, 248, 252);
  padding: 0px 24px 60px;
  &Bgc {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    width: 90%;
  }
  &More {
    display: block;
    width: 130px;
    height: 36px;
    line-height: 36px;
    margin: auto;
  }
}
.wrap {
  width: 100%;
  margin: auto;
  text-align: center;
  &Title {
    font-weight: bold;
    font-size: 18px;
    line-height: 28px;
    color: #3d3d3d;
    margin: 0;
  }
  &Desc {
    font-size: 12px;
    line-height: 20px;
    color: #3d3d3d;
    margin-bottom: 37px;
    margin: 4px 0 40px;
  }
  &List {
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    &Li {
      text-align: center;
      list-style: none;
      width: 96px;
      // height: 143px;
      margin: 0px 2px 15px 0;
      img {
        width: 85px;
        border-radius: 50%;
        background-color: #fff;
      }
      &Name {
        font-weight: bold;
        font-size: 16px;
        color: #3d3d3d;
        margin: 7px 0 6px;
      }
      &Desc {
        display: inline-block;
        width: 96px;
        font-size: 12px;
        line-height: 18px;
        color: #666;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
}
</style>
